import React from 'react';

const AdminFilters = ({
  filters,
  setFilters,
  onSearch,
  searchPlaceholder,
  filterOptions,
  filterKey,
  filterPlaceholder,
  // Optional second filter
  secondFilterOptions,
  secondFilterKey,
  secondFilterPlaceholder
}) => {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      onSearch();
    }
  };

  return (
    <div className="admin-filters">
      <input
        type="text"
        placeholder={searchPlaceholder}
        value={filters.search}
        onChange={(e) => setFilters({ ...filters, search: e.target.value })}
        onKeyDown={handleKeyDown}
      />
      <select
        value={filters[filterKey]}
        onChange={(e) => setFilters({ ...filters, [filterKey]: e.target.value })}
      >
        <option value="">{filterPlaceholder}</option>
        {filterOptions.map(opt => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </select>
      {secondFilterOptions && (
        <select
          value={filters[secondFilterKey] || ''}
          onChange={(e) => setFilters({ ...filters, [secondFilterKey]: e.target.value })}
        >
          <option value="">{secondFilterPlaceholder}</option>
          {secondFilterOptions.map(opt => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
      )}
      <button className="btn-search" onClick={onSearch}>Search</button>
    </div>
  );
};

export default AdminFilters;
